<template>
  <div class="page container">

    <div class="row mb-4">
      <div class="col-4">
        <div class="col-12 text-right">

          <router-link to="/">
            <img class="w-70 pull-right" alt="Vue logo" src="../assets/logo.svg">
          </router-link>
        </div>
      </div>
      <div class="col-8">
        <h1> Confirme seu pedido! </h1>
      </div>

    </div>



    <div v-if="enviando" class="mt-5">

      <b> Enviando seu pedido.... </b>

    </div>

    <div v-else>

      <div class="row mt-5" v-if="minhacesta.length == 0">
        <div class="col">
          <div class="alert alert-info">
            Você não possue nenhum produto na sua cesta. <router-link to="/"> Clique aqui para incluir os produtos
            </router-link>
          </div>
        </div>
      </div>


      <div class="row mt-5" v-if='error!=""'>
        <div class="col">
          <div class="alert alert-danger" v-html="error">

          </div>

        </div>
      </div>



      <div v-if="minhacesta.length > 0">

        <div class="row mt-5">

          <div class="col-12 text-left">

            <h4> Seus Dados </h4>
            <hr />

            <form class='text-left mt-5' ref="contato">



              <div class="form-group row">
                <label class="col-sm-2 col-form-label ">*Nome </label>
                <div class="col-sm-10">
                  <input v-model="usuario.nome" type="text" class="form-control" required>
                </div>
              </div>
              <!-- <div class="form-group row">
              <label class="col-sm-2 col-form-label" >*Email </label>
                      <div class="col-sm-10">
              <input v-model="usuario.email" type="email" class="form-control" required>
              </div>
            </div> -->
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">*Telefone </label>
                <div class="col-sm-10">
                  <input v-model="usuario.telefone" type="text" class="form-control" required>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">*Região </label>
                <div class="col-sm-10">

                  <select class="form-control " v-model="local" required>

                    <option value="0"> -- Escolha uma das regiões -- </option>

                    <option v-for="local in locaisEntregas" :key="local.id" :value="local.id">
                      {{local.nome}}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group row">
                <label class="col-sm-2 col-form-label">*Endereço </label>
                <div class="col-sm-10">
                  <input v-model="usuario.endereco" type="text" class="form-control" required>
                </div>
              </div>



            </form>

          </div>


        </div>


        <div class="row mt-5">
          <div class="col text-left">

            <h4> Resumo da compra </h4>
            <hr />
            <ul class="list-group list-group-flush resumo-compra">

              <li v-for="produto in minhacesta" :key="produto.id" class="list-group-item list-group-item-action">
                <b class='nome'>{{produto.nome}}</b> - <b> {{produto.quantidade}} {{produto.medida}}</b>
              </li>

            </ul>
            <router-link class='mt-2 d-block' to="/"> Editar </router-link>
          </div>


        </div>

        <div class="row mt-5">
          <div class="col text-left">
            <h4> Observação sobre o pedido? </h4>
            <hr />
            <div class="form-group row">
              <!-- <label class="col-sm-12 col-form-label text-left" for="">Observação sobre o pedido? </label> -->
              <div class="col-sm-12">
                <textarea class="form-control" v-model="usuario.observacao"> </textarea>
              </div>
              <!-- <small id="emailHelp" class="form-text text-muted">We'll never share your email with anyone else.</small> -->
            </div>

          </div>
        </div>

        <div class="row mt-3">

          <div class="col text-left">
            <!-- <h4> Total </h4> -->
            <hr />
            <h5> Total em Produtos <b> R$ {{ total }}</b> </h5>
            <h5> Taxa de entrega <b> R$ 15 </b> </h5>
            <h2> Total <b> R$ {{ total+15 }} </b> </h2>
            <hr />
            <!-- <h3> <b> Total em produtos: R$ {{ total }}</b> </h3> -->

          </div>
        </div>


        <div class="row mb-5">
          <div class="col">

            <a @click="confirmaPedido" class='btn btn-grande'> CONFIRME SEU PEDIDO </a>
            <router-link to="/" class='btn btn-primary '> Editar seu Pedido </router-link>
          </div>
        </div>


      </div>
    </div>
  </div>

</template>

<script>

export default {

  data(){
    return {
      error:'',
      enviando:false,
      enviado:false,
      // usuario:{
      //   nome:'',
      //   telefone:'',
      //   endereco:'',
      //   observacao:'',
      // }
    }
  },

  


  computed:{
          local:{
            set:function(val){
                this.$store.commit('localCliente',val)
            },
            get:function(){
                return this.$store.state.localCliente
            }
        },
    usuario:{
          get:function(){
              return this.$store.getters.cliente
          },
          set:function(val){
              this.$store.commit('cliente',val)
          }
    },
    
    locaisEntregas:function(){
            return this.$store.getters.locaisEntregas
    },


  listaProdutos:function(){
          return this.$store.getters.lista
      },
      minhacesta:function(){
          return this.$store.getters.minhacesta
      },
      total:function(){
          return this.$store.getters.total
      }
  },

  methods:{
    confirmaPedido:async function(){

      if(this.$refs['contato'].checkValidity()){

        this.enviando = true
        let res = await this.$store.dispatch('enviaPedido', this.usuario)
        this.enviando = false

        if(res.error==false){
            this.enviado = true
            this.$router.replace('pedidoencaminhado')
        }else{
          window.scrollTo(0,0)
          this.error = res.errormsg
        }
          
      }else{
          // alert("Preencha os dados")
             window.scrollTo(0,0)
          this.error = "Preencha os dados corretamente"
      }
    }
  }

}
</script>
